(function (angular) {
    'use strict';

    angular.module('sms')

        /**
         *
         */
        .factory('inboundService',
            ['$http', '$q', 'jwtService', 'portalConfig',
                function ($http, $q, jwtService, portalConfig) {

                    var urlBase = portalConfig.urlBase;
                    //urlBase = 'http://localhost:8001';

                    var fac = {
                        getDedicatedNumbers: getDedicatedNumbers,
                        getKeywords: getKeywords,
                        getShortcodes: getShortcodes,
                        updateForwardingUrl: updateForwardingUrl,
                        deleteForwardingUrl: deleteForwardingUrl
                    };

                    return fac;

                    /**
                     * @param {string} id - the api space Id
                     */
                    function getDedicatedNumbers(id) {
                        return $http.get(urlBase + "/apispaces/" + id + "/sms/dedicatedNumbers")
                            .then(getDedicatedNumbersComplete)
                            .catch(getDedicatedNumbersFailed);

                        function getDedicatedNumbersComplete(response) {
                            return response.data;
                        }

                        function getDedicatedNumbersFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * @param {string} id - the api space Id
                     */
                    function getKeywords(id) {
                        // return $q.resolve([{number: "60006", keyword: "SHUSTOP", countryIsoCode: "GBR"},{number: "60006", keyword: "SHUSTART", countryIsoCode: "GBR"}, {number: "60005", keyword: "FIVE", countryIsoCode: "GBR"}]);
                        return $http.get(urlBase + "/apispaces/" + id + "/sms/keywords")
                            .then(getKeywordsComplete)
                            .catch(getKeywordsFailed);

                        function getKeywordsComplete(response) {
                            return response.data;
                        }

                        function getKeywordsFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * @param {string} id - the api space Id
                     */
                    function getShortcodes(id) {
                        return $http.get(urlBase + "/apispaces/" + id + "/sms/shortcodes")
                            .then(getShortcodesComplete)
                            .catch(getShortcodesFailed);

                        function getShortcodesComplete(response) {
                            return response.data;
                        }

                        function getShortcodesFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    function updateForwardingUrl(id, numberId, forwardToUrl) {
                        return $http.post(urlBase + "/apispaces/" + id + "/sms/inbounds/" + numberId, { forwardToUrl: forwardToUrl })
                            .then(updateForwardingUrlComplete)
                            .catch(updateForwardingUrlFailed);

                        function updateForwardingUrlComplete(response) {
                            return response.data;
                        }

                        function updateForwardingUrlFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    function deleteForwardingUrl(id, numberId) {
                        return $http.delete(urlBase + "/apispaces/" + id + "/sms/inbounds/" + numberId)
                            .then(deleteForwardingUrlComplete)
                            .catch(deleteForwardingUrlFailed);

                        function deleteForwardingUrlComplete(response) {
                            return response.data;
                        }

                        function deleteForwardingUrlFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                }]);

})(window.angular);
